<template>
  <div>
    <div>
      <label for="ims-spectrum">
        IMS Spectrum:
      </label>
      <pre id="ims-spectrum">{{ selectedAgent && selectedAgent.IMS_spectrum }}</pre>
    </div>
    <div style="margin-top: 20px;">
      <label for="ms-spectrum">
        MS Spectrum:
      </label>
      <pre id="ms-spectrum">{{ selectedAgent && selectedAgent.MS_spectrum }}</pre>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['selectedAgent'])
  }
}
</script>

<style>
  label {
    font-weight: bold;
  }
</style>
